import { createSlice } from "@reduxjs/toolkit";

import {
    getIndividualCompletedLessons,
} from "redux/actions/studentLessons";
import {IReservationIndividualCompletedLesson} from "../../types/redux/reservation";

export interface IReservationIndividualCompleted {
    reservationIndividualCompleted:IReservationIndividualCompletedLesson[]|null;
    loading:boolean
}

const initial: IReservationIndividualCompleted = {
    reservationIndividualCompleted:null,
    loading:false
};

export const reservationIndividualCompletedSlice = createSlice({
    name: "reservationIndividualCompletedSlice",
    initialState: initial,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getIndividualCompletedLessons.pending, (state, action) => {
            state.loading= true;
        });
        builder.addCase(getIndividualCompletedLessons.fulfilled, (state, action) => {
            state.loading = false;
            state.reservationIndividualCompleted = action.payload;
        });
        builder.addCase(getIndividualCompletedLessons.rejected, (state, action) => {
            state.loading = false;
        });
    },
});

export const {} = reservationIndividualCompletedSlice.actions;

export default reservationIndividualCompletedSlice.reducer;
